import { JWTManager } from '../utils/jwt';

// Global authentication interceptor
class AuthInterceptor {
  private static instance: AuthInterceptor;
  private logoutCallback: (() => void) | null = null;

  private constructor() {}

  public static getInstance(): AuthInterceptor {
    if (!AuthInterceptor.instance) {
      AuthInterceptor.instance = new AuthInterceptor();
    }
    return AuthInterceptor.instance;
  }

  // Set the logout callback from AuthContext
  public setLogoutCallback(callback: () => void): void {
    this.logoutCallback = callback;
  }

  // Validate authentication before making API requests
  public validateAuth(): boolean {
    const isJwtValid = JWTManager.isTokenValid();
    
    if (!isJwtValid) {
      this.triggerLogout();
      return false;
    }
    
    return true;
  }

  // Handle authentication errors from API responses
  public handleAuthError(status: number, error?: string): boolean {
    if (status === 401 || status === 403) {
      console.warn('Error:', typeof error === 'string' ? error : 'Unknown error');
      this.triggerLogout();
      return false;
    }
    return true;
  }

  // Trigger logout if authentication fails
  private triggerLogout(): void {
    if (this.logoutCallback) {
      this.logoutCallback();
    } else {
      JWTManager.removeToken();
    }
  }

  // Check if user should be logged out based on token validity
  public shouldLogout(): boolean {
    return !JWTManager.isTokenValid();
  }
}

export const authInterceptor = AuthInterceptor.getInstance();
